<template>
<div class="tab-inner-left">
  <div class="form-module">
    <h2>Scratch-Off Prizes</h2>
    <p>Add promotional scratch rewards that will become active after the customer fills in and submits the form.</p>
    <div v-show="showError" class="text-danger py-2">No prize found</div>
    <div class="prize" v-for="(prize, index) in prizeList" :key="index">
      <h3>{{ prize.name }}</h3>
      <span v-if="errors.has(`prize_${index+1}`)" class="text-danger">{{ errors.first(`prize_${index+1}`).replace(`prize_${index+1}`, 'Prize Name') }}</span>
      <div class="descripted">
        <input class="al-input" type="text" placeholder="Type prize name here"
               @input="prizeNameChange(prize, $event)"
               :ref="`prize_${index+1}`" :name="`prize_${index+1}`"
               :data-vv-name="`prize_${index+1}`"
               :value="prize.name"
               v-validate="prize.name !== '' ? '' : 'required'">
      </div>
      <div class="descripted">
        <input class="al-input" type="text" placeholder="Enter your requirements to claim"
               @input="prizeClaimChange(prize, $event)"
               :ref="`prize_claim_${index+1}`" :name="`prize_claim_${index+1}`"
               :data-vv-name="`prize_claim_${index+1}`"
               :value="prize.claim"
               v-validate="''">
      </div>
      <div class="descripted">
        <h2>Rate <span style="font-weight: normal;">(Winning probability %)</span></h2>
        <input class="al-input" type="text" placeholder="Rate"
               @input="prizeRateChange(prize, $event)"
               :ref="`prize_rate_${index+1}`" :name="`prize_rate_${index+1}`"
               :data-vv-name="`prize_rate_${index+1}`"
               :value="prize.rate"
               v-validate="prize.rate !== '' ? '' : 'required'">
      </div>
      <div class="descripted">
        <h2>Day Of Week <span style="font-weight: normal;"></span></h2>
        <div class="day-selection" v-for="(day, dayIndex) in prize.days" :key="dayIndex">
          <div class="daynameselection">
          <input type="checkbox" :id="`day-${index}-${dayIndex}`" v-model="day.selected">
          <label class="dayname" :for="`day-${index}-${dayIndex}`">{{ day.name }}</label>
          </div>
          <div v-if="day.selected" class="day-timer">
            <!-- Start Time -->
            <input type="time" :id="`start-time-${index}-${dayIndex}`" v-model="day.startTime"> - <input type="time" :id="`end-time-${index}-${dayIndex}`" v-model="day.endTime">
          </div>
          <span  v-if="day.selected"></span>
        </div>
      </div>
      <h4>Upload Prize Image</h4>
      <upload-image :required="prize.image_id === ''"
                    :code="`prize_image_${index+1}`"
                    :img_id="(prize.image_id === '') ? null : prize.image_id"
                    :index="index" :callback="imageUploaded" />
      <label class="remove al-button remove-prize red-button" @click="deletePrize(prize)">
        <i class="fas fa-trash"></i> Delete Prize
      </label>
      <div class="flex">
        <span>Disabled</span>
        <vs-switch class="switch-button mx-2" :value="prize.text_enabled" @input="prizeEnabledChange(prize, $event)" />
        <span>Enabled</span>
      </div>
    </div>
    <div class="add-more al-button"  @click="addPrize"><i class="fas fa-plus"></i> Add More Prize</div>
  </div>
</div>
</template>

<script>

import UploadImage from '../../../../layouts/components/navbar/UploadImage'
export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      create: true,
      showError: false,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      name: '',
      logo_id: '',
      title: '',
      offer: '',
      campaign_image_id: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: true
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: [],
      prizeList: [],
      prizeDefault: {
        name: '',
        claim: '',
        rate: 0,
        image_id: '',
        days: []
      },
      campaign_name_focused: false,
      campaign_slogan_focused: false,
      campaign_award_focused: false,
      daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    }
  },
  components: {
    UploadImage
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    campaign_name_focused () {
      this.update_data()
    },
    dataVal () {
      this.set_data()
    },
    prizeList () {
      this.update_data()
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    }
  },
  methods: {
    showValidationError () {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 5000)
    },
    prizeNameChange (prize, e) {
      prize.name = e.target.value
      this.update_data()
    },
    prizeClaimChange (prize, e) {
      prize.claim = e.target.value
      this.update_data()
    },
    prizeRateChange (prize, e) {
      prize.rate = e.target.value
      console.log(prize)
      this.update_data()
    },
    prizeEnabledChange (prize, e) {
      console.log('prize e', prize, e)
      prize.text_enabled = e
      this.update_data()
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deletePrize (prize) {
      this.openConfirm(() => {
        const index = this.prizeList.indexOf(prize)
        this.prizeList.splice(index, 1)
        this.update_data()
      }, () => {})

    },
    addPrize () {
      this.prizeList.push({
        name: '',
        claim: '',
        rate: 0,
        image_id: '',
        days: this.daysOfWeek.map(day => ({ name: day, selected: false, startTime: '', endTime: '' }))
      })
      console.log(this.prizeList)
    },
    imageUploaded (result, index) {
      console.log(index, result)
      this.prizeList[index].image_id = result

      console.log(this.prizeList[index])
      this.update_data()
    },
    onCheckChange (option, e) {
      console.log('check change')
      console.log(e.target.value)


      const index = this.fieldList.findIndex(x => x === e.target.value)
      //const name_index = this.fieldnames.findIndex(x => x === e.target.value)
      // here you can check specific property for an object whether it exist in your array or not

      index === -1 ? this.fieldList.push(e.target.value) : this.fieldList.splice(index, 1)
      //this.fieldnames[name_index].value = !this.fieldnames[name_index].value
      console.log(this.fieldList)
      this.update_data()
    },
    set_data () {
      const { prizeList } = JSON.parse(JSON.stringify(this.dataVal))
      this.prizeList = prizeList
      this.prizeList.forEach(prize => {
        if (!prize.days || prize.days.length === 0) {
          this.$set(prize, 'days', this.daysOfWeek.map(day => ({ name: day, selected: false, startTime: '', endTime: '' })))
        }
      })
      console.log('setting data', this.dataVal)
    },
    update_data (ref) {
      this.update(this.prizeList)
      this.$store.commit('SET_EDITING_NOW', ref)
    }
  }
}
</script>

<style lang="scss">
.prize{
  position:relative;
  .remove-prize{
    position:absolute;
    top:0;
    right:-24px;
    transform:scale(0.6);
  }
}
.days-of-week .day-of-week {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.days-of-week label {
  margin-left: 8px;
  margin-right: 16px; /* Label ve sonraki input elementi arasında boşluk */
}
.day-selection {
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  background: #fff;
  padding: 0 10px;
  color: #728a9a;
  position:relative;
  display: flex;
   /*width: 471px;*/
  height: 57px;
  padding: 16px;
  gap: 220px;
  border-radius: 12px;
  border: 1px solid var(--Main-Color-Main-100, #003451);

input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;
  outline: none;
  margin-right: 10px;
  border: 1px solid #cccccc;
  border-radius: 0px;
  background-color: #fff;
}
input[type="checkbox"]:checked::before {
  content: '';
  position: absolute;
  left: 5px;
  top: 0px;
  width: 8px;
  height: 15px;
  border: solid #0d3652; /* Checkmark color */
  border-width: 0 5px 5px 0;
  transform: rotate(45deg);
}
input[type="checkbox"]:checked {
  border-color: #0d3652;
}
input[type="checkbox"]:hover {
  background-color: #f0f0f0;
}
label{
  font-size:28px;
}
.orange-border{
  width:8px;
  height:42px;
  //background-color:#ff7422;
  display:block;
  position:absolute;
  right:0;
}
  .day-timer{
    display: flex;
    align-items: flex-start;
    gap: 0px;
    input {
      color: var(--Main-Color-Main-100, #003451);
      font-variant-numeric: lining-nums proportional-nums;

      /* Title Styles/Title Small */
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 171.429% */
    }
  }
  .dayname {
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;

    /* Title Styles/Title Small */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    padding-top: 10px;
  }
  .daynameselection {
    display: flex;
    width: 130px;
    gap: 8px;
    flex-shrink: 0;
    align-items: center;
  }
}
</style>
